export default "__VITE_ASSET__Cqn5IgwW__"